import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { topUserVoiceSliderItems } from '@/components/modules/pages/top/slider/TopUserVoiceSlider/const';
import { TopUserVoiceSliderItem } from '@/components/modules/pages/top/slider/TopUserVoiceSlider/TopUserVoiceSliderItem';
import { SliderBase } from '@/components/ui/Slider/SliderBase';
import { getScreenValueOfNumber } from '@/utils/style/config';
/** スライダー設定 */
const setting = {
    arrows: true,
    centerMode: true,
    centerPadding: '16px',
    infinite: true,
    responsive: [
        {
            breakpoint: getScreenValueOfNumber('lg') - 1,
            settings: {
                arrows: false,
                slidesToShow: 1,
            },
        },
    ],
    slidesToScroll: 1,
    slidesToShow: 1,
    variableWidth: true,
};
const customNextButtonProps = {
    customClassName: 'lg:!right-[calc(50%_-_472px)] xl:!right-[calc(50%_-_472px)]',
};
const customPrevButtonProps = {
    customClassName: 'lg:!left-[calc(50%_-_472px)] xl:!left-[calc(50%_-_472px)]',
};
export const TopUserVoiceSlider = (props) => {
    const { className = '' } = props;
    return (_jsx("div", Object.assign({ className: className }, { children: _jsx(SliderBase, Object.assign({ customNextButtonProps: customNextButtonProps, customPrevButtonProps: customPrevButtonProps, setting: setting }, { children: topUserVoiceSliderItems.map((item, index) => (_jsx("div", Object.assign({ className: clsx('w-full', 'py-4 px-4 md:px-16') }, { children: _jsx(TopUserVoiceSliderItem, { item: item, itemNumber: index + 1 }) }), `TopUserVoiceSlider_item_${index + 1}`))) })) })));
};
